var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-text"},[_c('div',{staticClass:"vx-row mb-12"},[_c('div',{staticClass:"core vx-col md:w-1/1 w-full mb-base"},[_c('data-table',{attrs:{"baseUrl":_vm.baseUrl,"status":1}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }